import { ImageAttribution } from "./ImageAttribution";

export class ImageInfo {
  url?: string;
  attribution?:ImageAttribution
}


